import { z } from 'zod';
import { filterParam } from '@/lib/url-state';

export const OPERATOR_TABS = ['overview', 'brands', 'configs'] as const;
export type OperatorTab = (typeof OPERATOR_TABS)[number];

export const operatorDetailSearchSchema = z.object({ tab: filterParam.enum(OPERATOR_TABS) });
